const ATTRIBUTES_TO_REMOVE = [
  'data-slate-node',
  'data-slate-leaf',
  'data-slate-string',
  'data-slate-zero-width',
  'data-slate-length',
  'data-slate-inline',
  'data-slate-void',
  'data-slate-spacer',
  'data-slate-editor',
  'contenteditable',
  'suppresscontenteditablewarning',
  'data-gramm',
  'data-gramm_editor',
  'spellcheck',
  'data-element-super-id',
  'data-document-revision-id',
  'data-element-revision-id',
];

const CLASSES_TO_REMOVE = ['layout-leaf', 'layout-leaf-empty'];

const sanitizeElement = (el: Element): void => {
  ATTRIBUTES_TO_REMOVE.forEach((attr) => {
    el.removeAttribute(attr);
  });

  CLASSES_TO_REMOVE.forEach((cls) => {
    el.classList.remove(cls);
  });

  if (el.classList.length === 0) {
    el.removeAttribute('class');
  }
};

const cleanTextContent = (doc: Node): void => {
  const walker = document.createTreeWalker(doc, NodeFilter.SHOW_TEXT, null);
  const nodesToRemove: Node[] = [];

  let node: Node | null;
  while ((node = walker.nextNode())) {
    node.textContent = (node.textContent ?? '').replace(/[\u200B\u200C\u200D\uFEFF]/g, '');

    if (node.textContent === '') {
      nodesToRemove.push(node);
    }
  }

  nodesToRemove.forEach((n) => (n as ChildNode).remove());
};

const removeEmptyAnchors = (doc: Element): void => {
  const anchors = doc.querySelectorAll('a');
  anchors.forEach((a) => {
    if (a.innerHTML.trim() === '' && a.getAttribute('href')?.startsWith('#anchor-')) {
      a.remove();
    }
  });
};

const removeEmptySpans = (doc: Element): void => {
  const spans = doc.querySelectorAll('span');
  spans.forEach((span) => {
    if (span.innerHTML.trim() === '' || span.innerHTML === '<br>') {
      const parent = span.parentElement;
      if (parent && parent.children.length === 1 && span.querySelector('br')) {
        span.replaceWith(document.createElement('br'));
      } else if (span.innerHTML.trim() === '') {
        span.remove();
      }
    }
  });
};

const unwrapSpans = (doc: Element): void => {
  const spans = doc.querySelectorAll('span');
  spans.forEach((span) => {
    if (span.attributes.length === 0) {
      span.replaceWith(...span.childNodes);
    }
  });
};

export const sanitizeSlateHtml = (html: string): string => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  const allElements = doc.body.querySelectorAll('*');
  allElements.forEach(sanitizeElement);

  cleanTextContent(doc.body);

  removeEmptyAnchors(doc.body);

  removeEmptySpans(doc.body);
  unwrapSpans(doc.body);

  return doc.body.innerHTML;
};
